import React from 'react'
import PropTypes from 'prop-types'

import ExclusionModal from '../ExclusionModal/ExclusionModal'

class Table extends React.Component {
  static propTypes = {
    records: PropTypes.array,
    translate: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
  }

  renderHeader() {
    const { translate } = this.props

    return (
      <tr>
        <th className='text-align-left' width='300px'>
          {translate(`label.exclusion.subtype.dsSection`)}
        </th>
        <th className='text-align-left'>
          {translate(`label.exclusion.subtype.dsSubtype`)}
        </th>
        <th className='text-align-center' width='250px'>
          {translate(`label.exclusion.subtype.remove`)}
        </th>
      </tr>
    )
  }

  renderRow = (row, i) => {
    const { handleDelete, translate } = this.props

    return (
      <tr key={i}>
        <td>{row.dsSection}</td>
        <td>{row.dsSubtype}</td>
        <td className='text-align-center'>
          <ExclusionModal
            t={translate}
            title={translate('label.exclusion.subtype.remove.block')}
            message={
              <>
                <p>{translate(`label.exclusion.subtype.remove.question`)}</p>
                {translate('section')}: <b>{row.dsSection}</b>
                <br />
                {translate('subType')}: <b>{row.dsSubtype}</b>
              </>
            }
            confirmButtonMsg='button.yes.remove.subtype'
            onConfirm={() => handleDelete([row.idExclusion])}
            renderButton={({ onClick }) => (
              <a className='trash-icon-padding' role='button' onClick={onClick}>
                <i className='color-danger glyph glyph-trash-can icon-size' />
              </a>
            )}
          />
        </td>
      </tr>
    )
  }

  render() {
    const { records } = this.props

    return (
      <table cellPadding={0} cellSpacing={0} className='new-table'>
        <thead>{this.renderHeader()}</thead>
        <tbody>{records.map(this.renderRow)}</tbody>
      </table>
    )
  }
}

export default Table
export { Table }
